import { Modal, Typography } from 'antd';
import React from 'react';
import './ModalCustom.scss';

const { Text, Title } = Typography;

interface ModalCustomProps {
  title: string;
  description: string;
  footer?: React.ReactNode;
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  children?: React.ReactNode;
}

const ModalCustom = ({ title, description, footer, children, isModalOpen, setIsModalOpen }: ModalCustomProps) => {
  return (
    <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={footer}>
      <Title className={'ModalCustom__titleSection__title'} level={4}>
        {title}
      </Title>
      <div className={'ModalCustom__descriptionSection'}>
        <Text className={'ModalCustom__descriptionSection__description'}>{description}</Text>
      </div>
      {children}
    </Modal>
  );
};

export default ModalCustom;
